import { render, staticRenderFns } from "./ModalAutorizacaoContestacaoMedica.vue?vue&type=template&id=dbee8060&scoped=true"
import script from "./ModalAutorizacaoContestacaoMedica.vue?vue&type=script&lang=ts"
export * from "./ModalAutorizacaoContestacaoMedica.vue?vue&type=script&lang=ts"
import style0 from "./ModalAutorizacaoContestacaoMedica.vue?vue&type=style&index=0&id=dbee8060&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbee8060",
  null
  
)

export default component.exports